<template>
    <b-card body-class="flightCard" @click="() => $emit('click')">
        <p class="h4 mt-0 mb-0">
            <strong>{{ flightData.number }}</strong> |
            <small>{{ flightData.airline }}</small>
        </p>
        <b-row no-gutters>
            <b-col>
                <p class="mb-0 airportName">{{ flightData.departure.airportName }}</p>
                <p class="mb-0 flightSchedule" v-if="departureDatetime.isValid()">
                    <strong>{{ departureDatetime | $moment('HH:mm') }}</strong> |
                    <small>{{ departureDatetime | $moment('dddd, D MMM YYYY') }}</small>
                </p>
                <p class="mb-0 flightSchedule" v-else>El horario no esta disponible</p>
            </b-col>
            <b-col cols="1">
                <md-icon :icon="'arrow_forward'"/>
            </b-col>
            <b-col>
                <p class="mb-0 airportName">{{ flightData.arrival.airportName }}</p>
                <p class="mb-0 flightSchedule" v-if="arrivalDatetime.isValid()">
                    <strong>{{ arrivalDatetime | $moment('HH:mm') }}</strong> |
                    <small>{{ arrivalDatetime | $moment('dddd, D MMM YYYY') }}</small>
                </p>
                <p class="mb-0 flightSchedule" v-else>{{ $t("bookings.scheduleNotAvailable") }}</p>
            </b-col>
        </b-row>
    </b-card>

</template>

<script>
    export default {
        name:'FlightItem',
        props: {
            flightData: {
                type: Object,
            }
        },
        data(){
            return {

            }
        },
        computed: {
            departureDatetime() {
                // eslint-disable-next-line
                return this.$moment(this.flightData.departure.scheduledTime??'--');
            },
            arrivalDatetime() {
                // eslint-disable-next-line
                return this.$moment(this.flightData.arrival.scheduledTime);
            },
        },
        mounted() {},
    };
</script>

<style scoped>
    .flightCard {
        cursor: pointer;
        padding: 5px 10px !important;
    }
    .airportName {
        line-height: 20px;
    }
    .flightSchedule {
        font-size: 18px;
        line-height: 25px;
    }
    .icon {
        font-size: 35px;
    }
</style>
